import BlogPosts from '@components/BlogPosts';
import * as React from 'react';
export default {
  BlogPosts,
  React
};